import { useAppSelector } from '@/hooks/useAppSelector';

import { authUser } from '../services/selectors/auth';

export const useUser = () => useAppSelector(authUser);
